import React from "react";
import { cn } from "@/lib/utils";
import TextCardToggle from "@/components/ui/text-card-toggle";
import NewsletterForm from "@/components/forms/newsletter-form";

export interface ProductDescriptionProps {
  id?: string;
  className?: string;
  title?: string;
  description?: string | React.ReactNode;
  additionalData?: { title?: string; description?: string | React.ReactNode }[];
  color?: "light-orange" | "white";
}

const ProductDescription: React.FC<ProductDescriptionProps> = ({
  id = "product-description",
  className,
  title = "Section Title",
  description = (
    <div className="flex flex-col gap-2">
      <p>
        Lorem ipsum dolor sit amet consectetur. In nunc nunc nibh tristique
        pulvinar eget. Venenatis metus nec egestas et commodo id porta in
        blandit. Ultricies viverra adipiscing felis neque sed odio. Orci cursus
        dignissim ac erat. Semper et euismod dui consectetur vestibulum. Viverra
        congue lacus gravida at. Eget vestibulum massa sit a nunc blandit nisi
        leo. Ornare proin non in congue lobortis turpis id et. Dignissim ligula
        dapibus gravida nunc placerat lorem habitasse. Volutpat ut aliquam in
        turpis quam sed. Urna ullamcorper potenti mattis feugiat proin. Massa
        tempus amet aliquet amet donec sed pharetra. Orci nisl eu ut egestas.
      </p>
      <p>
        Enim tortor tristique in ut vel. Enim a donec dui diam nunc. Eget dui id
        purus risus convallis eu sed adipiscing nunc. Purus pretium nibh quis
        justo nunc. Aliquet fames volutpat nullam sapien purus.
      </p>
    </div>
  ),
  additionalData,
  color = "light-orange", // Default to "light-orange"
}) => {
  return (
    <section
      id={id}
      aria-label={id}
      className={cn(
        color === "light-orange" ? "bg-primary-100" : "bg-white", // Apply background class
        className
      )}
    >
      <div className="mx-auto flex w-full max-w-lg flex-col gap-6 p-4 md:px-6 md:py-8 lg:flex-row lg:justify-between lg:gap-10 lg:px-3 lg:py-10">
        <div className="flex flex-col gap-8">
          <TextCardToggle
            variant="mobile"
            className="flex w-full lg:col-span-7 lg:w-[725px]"
            containerClassName="gap-2 md:gap-3 lg:gap-4"
            titleClassName="font-montserrat !text-secondary-500 text-heading-4 md:text-heading-3 lg:text-heading-2"
            title={title}
            contentClassName="md:!h-fit"
            defaultCollapsed={true}
            collapsedHeight={144}
            toggleClassName="md:hidden"
          >
            {typeof description === "string" ? (
              <div
                className="rich-text [&_a]:hover:text-primary-700 [&_a]:focus:text-primary-700 [&_a]:rounded-md [&_a]:font-roboto [&_a]:text-body-1-400 [&_a]:text-primary-600 [&_a]:underline [&_a]:underline-offset-2 [&_a]:hover:no-underline [&_a]:focus:no-underline [&_a]:focus:outline [&_a]:focus:outline-1 [&_a]:focus:outline-offset-2 [&_a]:focus:outline-black"
                dangerouslySetInnerHTML={{ __html: description || "" }}
              />
            ) : (
              description
            )}
          </TextCardToggle>
          {additionalData &&
            additionalData.length > 0 &&
            additionalData.map(({ title, description }) => (
              <TextCardToggle
                key={`additional-data-${title}`}
                variant="mobile"
                className="flex w-full lg:col-span-7 lg:w-[725px]"
                containerClassName="gap-2 md:gap-3 lg:gap-4"
                titleClassName="font-montserrat !text-secondary-500 text-heading-4 text-heading-3 md:text-heading-3 lg:text-heading-2"
                title={title}
                contentClassName="md:!h-fit"
                defaultCollapsed={true}
                collapsedHeight={144}
                toggleClassName="md:hidden"
              >
                {typeof description === "string" ? (
                  <div
                    className="rich-text"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                ) : (
                  description
                )}
              </TextCardToggle>
            ))}
        </div>
        <div className="flex w-full justify-center lg:w-fit">
          <NewsletterForm />
        </div>
      </div>
    </section>
  );
};

export default ProductDescription;
